export default "__VITE_ASSET__LXr96_wn__"